import * as React from 'react';
import { Redirect } from 'react-router-dom';
import {
  Wrapper,
  Content,
  BoxWrapper
} from './styled';

import { SidebarFeature } from '@app/src/commons/sidebar';
import { useAuthorization } from '@app/src/utils/validations';
import { HeaderFeature } from '@app/src/commons/header';
import { FormFeature } from './createUSer';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { getSettings } from '@app/src/configuration/config.service';

interface Props {
  history: any;
}

export const CreateUsers: React.FC<Props> = ({ history }) => {
  const isNotAuthorization: boolean = !useAuthorization();

  if (isNotAuthorization) {
    return <Redirect to="/" />
  }

  const isAdmin: boolean = decodeAccessToken('isAdmin');
  if (isAdmin) {
    return (
      <Wrapper>
        <SidebarFeature history={history} />
        <Content>
          <BoxWrapper>
            <HeaderFeature subTitle="Nuevo Usuario" />
            <FormFeature url={getSettings().API_USER} />
          </BoxWrapper>
        </Content>
      </Wrapper>
    );
  }

  return <Redirect to="/generarcip" />;
};
